module.exports = __webpack_public_path__ + "img/wx2.b6f9b817.jpg";